<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomLoader from "@/components/widgets/custom-loader";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Students Summery",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
  },
  data() {
    return {
      title: "Students Summery",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Students Summery",
          active: true,
        },
      ],
      filterData: {
        class: "",
        term: "",
        year: "",
        stream: "",
      },
    };
  },
  computed: {
    ...mapGetters("students", [
      "SaveStatus",
      "getStudentsSummery",
      "FetchingStudents",
    ]),
    ...mapGetters("classes", ["AllStreams", "AllClasses", "AllClassStreams"]),
    ...mapGetters("marks", ["getYears"]),
        ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchStudentsSummery: "students/fetchStudentsSummery",
      FetchYears: "marks/fetchYear",
      FetchStreams: "classes/fetchStreams",
      FetchClasses: "classes/fetchClasses",
      FetchClassStreams: "classes/fetchClassStreams",
    }),

    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },

    submitFilter() {
      this.FetchStudentsSummery(this.filterData);
    },
  },
  created() {
    this.FetchStudentsSummery(this.filterData);
    this.FetchClasses();
    this.FetchStreams();
    this.FetchYears();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('student_summery')
        )
      "
    >
      <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a
                v-b-toggle.accordion-1
                class="text-primary"
                href="javascript: void(0);"
                ><u> Click to Filter Students</u>
                <i class="fa fa-filter" aria-hidden="true"></i
              ></a>
            </h6>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <form @submit.prevent="submitFilter()">
                <div class="row">
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Year <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.year"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Year</option>
                        <option
                          v-for="(schyear, index) in getYears"
                          :value="schyear.year"
                          :key="index"
                        >
                          {{ schyear.year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Term <small class="text-danger">*</small></label
                      >
                      <select
                        required
                        class="form-control form-control-sm"
                        v-model="filterData.term"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Term</option>
                        <option value="1">Term 1</option>
                        <option value="2">Term 2</option>
                        <option value="3">Term 3</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Class <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.class"
                        @change="fetchStreamsinClass($event)"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Class</option>
                        <option
                          v-for="(classes, index) in AllClasses"
                          :key="index"
                          :value="classes.id"
                        >
                          {{ classes.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Stream
                        <small class="text-primary">(Optional)</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        v-model="filterData.stream"
                        name=""
                        id=""
                      >
                        <option v-if="SaveStatus" value="" selected disabled>
                          Fetching Streams...
                        </option>
                        <option v-else value="" selected disabled>
                          Select Stream
                        </option>
                        <option
                          v-for="(stream, index) in AllClassStreams"
                          :value="stream.id"
                          :key="index"
                        >
                          {{ stream.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mt-3">
                    <button
                      type="submit"
                      size="sm"
                      disabled
                      class="btn btn-sm btn-outline-primary mt-2"
                      v-if="FetchingStudents"
                    >
                      <b-spinner
                        variant="primary"
                        small
                        label="Fetching Data..."
                      ></b-spinner>
                      Fetching Data...
                    </button>
                    <button
                      v-else
                      type="submit"
                      size="sm"
                      class="btn btn-sm btn-outline-primary mt-2"
                    >
                      <i class="fa fa-check"></i>
                      Submit Filers
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <CustomLoader v-if="FetchingStudents"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3
                  class="card-title text-primary"
                  v-if="this.filterData.class"
                >
                  Student's Summery in {{ this.filterData.year }}
                  <span>, Term {{ this.filterData.term }}</span>
                  <span v-if="this.filterData.class != 0"
                    >, Class: {{ getStudentsSummery.class_details.short }}</span
                  >
                  <span v-if="this.filterData.stream != 0"
                    >, Stream:
                    {{ getStudentsSummery.stream_details.name }}</span
                  >
                </h3>
                <h3 class="card-title text-primary" v-else>
                  Use the Filter Above to Filter Students
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <b-tabs
                      justified
                      nav-class="nav-tabs-custom"
                      content-class="p-3 text-muted"
                    >
                      <b-tab active>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="fas fa-home"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >Class Summery</span
                          >
                        </template>
                        <div class="table-responsive mb-0 mx-5">
                          <table class="table align-middle table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th class="align-middle">Class</th>
                                <th class="align-middle">Students Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  stdClass, index
                                ) in getStudentsSummery.class_summery"
                                :key="index"
                              >
                                <td>{{ stdClass.class.name }}</td>
                                <td>{{ stdClass.count }}</td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th class="align-middle">Total</th>
                                <th class="align-middle">
                                  {{ getStudentsSummery.total_std }}
                                </th>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-user"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >Gender Summery</span
                          >
                        </template>
                        <div class="table-responsive mb-0 mx-5">
                          <table class="table align-middle table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th class="align-middle">Gender</th>
                                <th class="align-middle">Students Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  stdGender, index
                                ) in getStudentsSummery.gender_summery"
                                :key="index"
                              >
                                <td>{{ stdGender.gender }}</td>
                                <td>{{ stdGender.count }}</td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <th class="align-middle">Total</th>
                                <th class="align-middle">
                                  {{ getStudentsSummery.total_std }}
                                </th>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-envelope"></i>
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >Residents Summery</span
                          >
                        </template>
                        <div class="table-responsive mb-0 mx-5">
                          <table class="table align-middle table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th class="align-middle">Residence Status</th>
                                <th class="align-middle">Students Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(
                                  stdResidence, index
                                ) in getStudentsSummery.residence_summery"
                                :key="index"
                              >
                                <td>
                                  {{
                                    stdResidence.residence == 2
                                      ? "Boarding"
                                      : "Day"
                                  }}
                                </td>
                                <td>{{ stdResidence.count }}</td>
                              </tr>
                            </tbody>
                            <thead>
                              <tr>
                                <th class="align-middle">Total</th>
                                <th class="align-middle">
                                  {{ getStudentsSummery.total_std }}
                                </th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
